import { render } from "./expensecategory.vue?vue&type=template&id=6aa4f371"
import script from "./expensecategory.vue?vue&type=script&lang=js"
export * from "./expensecategory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__